'use strict';

app.controller('DialerCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
  $rootScope.dialer = false;
  $scope.rootScope = $rootScope;
  $scope.url = 'https://myringover.com/';
  $scope.phone = '';
}]);
